import { isProduction } from '..';

export interface IProductUuid {
  uuid: string;
}

export const devToolsEnabled: () => boolean = () =>
  process.env.REACT_APP_DEV_TOOLS === 'true' &&
  !isProduction();
